import { html, ref, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils';
export const getPrefixedFileUpload = (prefix) => html `
<template>
  <div class="file-selection">
    <input type="file" multiple ${ref('fileInput')} 
    @change=${(x, c) => x.onInputChange(c.event)} :accept="${(x) => x.accept}"/>
    <${prefix}-text-field readOnly type="text" id="fileName" part="file-name-input" class="file-name-input"
        :label="${(x) => x.label}" 
        :value="${(x) => x.fileName}">
        ${(x) => x.label} 
        ${when((x) => x.fileName, html `
        <${prefix}-icon slot="end" class="clear-icon" name="xmark" 
          @click=${(x) => x.clearSelection()}></${prefix}-icon>
          `)}
    </${prefix}-text-field>

    <${prefix}-button @click=${(x) => x.handleClick()} part="select-file-button">Browse</${prefix}-button>
    <${prefix}-button @click=${(x) => x.handleFileUpload()} part="upload-file-button"
      :disabled="${(x) => !x.fileName}" >Upload</${prefix}-button>
  </div>
  <div class="uploader-grid">
      <${prefix}-data-grid generate-header="sticky" part="uploaded-files-grid"
      :rowsData="${(x) => x.uploadedFilesList}"
      :columnDefinitions="${(x) => x.filesGridColumnDefinitions}">         
      </${prefix}-data-grid>
  </div>
</template>
`;
export const foundationFileUploadTemplate = html `
  ${(x) => getPrefixedFileUpload(getPrefix(x))}
`;
